import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ie_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default client;

export async function login(email, password) {
  const { data } = await client.post("/auth/login", { email, password });
  localStorage.setItem("ie_token", data.token);
  localStorage.setItem("ie_email", data.email);
  return data;
}

export function logout() {
  localStorage.removeItem("ie_token");
  localStorage.removeItem("ie_email");
}

export function isAuthed() {
  return !!localStorage.getItem("ie_token");
}
